import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class RouteGuardCommunicationService {
    public displayAccessDeniedToast: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}
